export default "__VITE_ASSET__BXgBJBhE__"